
exports.articleUrl = (slug) => `/news/${slug}/`;
exports.partnerUrl = (slug) => `/partners/${slug}/`;